module.exports = __webpack_public_path__ + "static/09.05.01.createRecipe.steps-04f4fe2b4636af9fee1eca4b365e6834.png";